/**
 * Hook for fetching invoice queries using clean architecture
 * @param documentId - Invoice document ID
 */
import { useQueriesBySource } from "../../../../shared/queries/presentation/hooks/useQueriesBySource";

export const useInvoiceQueries = (documentId: string | null) => {
  const { queries, loading, loadingMore, error, refetch, hasMore, loadMore } =
    useQueriesBySource(
      "invoice",
      documentId ? parseInt(documentId) : undefined
    );

  return { queries, loading, loadingMore, error, refetch, hasMore, loadMore };
};
